module.exports = __webpack_public_path__ + "img/意向受让.08082def.png";